import { EMAIL_ADDRESSES } from 'src/config';

export const onBusinessClick = (subject: string = 'Business pricing') => {
  window.open(
    `mailto:${EMAIL_ADDRESSES.sales}?subject=${encodeURIComponent(subject)}`,
    '_blank'
  );
};
